<template>
  <div @click="emitClick">
    <input type="checkbox" :id="inputId" v-model="isChecked" :disabled="disabled" @change="emitChange" />
    <label :for="inputId">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  data: () => ({
    inputId: null,
    isChecked: false,
  }),
  props: {
    id: {
      type: String,
    },
    checked: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change', this.isChecked);
    },
    emitClick() {
      this.$emit('click', this.disabled);
    },
  },
  created() {
    // eslint-disable-next-line no-underscore-dangle
    this.inputId = this.id || `checkbox_${this._uid}`;
    this.isChecked = this.checked || false;
  },
};
</script>

<style scoped lang="scss">
input {
  display: none;
}
label {
  display: block;
  padding-block: 0;
  padding-inline: rem(24px) 0;
  position: relative;
}
input[type="checkbox"]:disabled + label {
  opacity: .7;
}
input[type="checkbox"] + label::before {
  width: rem(20px);
  height: rem(20px);
  border: 2px solid $color-kws-black-15;
  background-color: #fff;
  display: block;
  content: "";
  position: absolute;
  inset-inline-start: 0;
}

input[type="checkbox"]:checked + label::before {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4gIDxnIGZpbGw9Im5vbmUiPiAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiNGRjZDMDAiLz4gICAgPHBvbHlnb24gZmlsbD0iI0ZGRiIgcG9pbnRzPSI4LjY4OCAxMi44MyA0LjkzNyA5LjgyOSAzLjA2MyAxMi4xNzEgOS4zMTIgMTcuMTcgMTcuMjI5IDUuODYgMTQuNzcxIDQuMTQiLz4gIDwvZz48L3N2Zz4=);
  border: 0;
}
</style>
